// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"eee8d45b","498":"5df1f742","703":"01115f59","787":"1cd31a9e"}[chunkId] + ".chunk.js";
};